import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        AlertBanner
    }
})

export default class GrossingTouchPeopleSidepanel extends Vue {
}
